//import bg from "../public/bg.jpg";
import abi from "./utils/nft.json";
import SpinnerOverlay from "./utils/Spinner";
import copyIcon from "./copy.svg";
import "./App.css";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
//98224d4e1aa436d5b8fea301e0ff3c53
import {
 useWeb3ModalProvider,
 useWeb3ModalAccount,
} from "@web3modal/ethers/react";
import { BrowserProvider, Contract, formatUnits, parseUnits } from "ethers";
//import { createWeb3Modal, defaultConfig } from "@web3modal/ethers5/react";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import CountdownTimer from "./Countdown/CountdownTimer";
import { ReadContract } from "./utils/readContract";
import { Allowance } from "./utils/allowance";
import { message } from "antd";
import Spinner from "react-spinkit";

// 1. Get projectId
const projectId = "98224d4e1aa436d5b8fea301e0ff3c53";
//const token = "0x6c206A495611B9D0b4C2b70316738cAeB01a69Cc";
const token = "0x55d398326f99059fF775485246999027B3197955";
//const token = "0xaC8A6B542DEe616a90C06FD0f490412B96618cBB";
//const ca = "0x40c7696E2B89f551e288322E52b22c2Fa6B319E8";
//TEST;
const ca = "0x62951Bc57BCEF1ECDD513522023e3F8A770ED5A4";
const time = Date.now();
//LAST 0xae287547Cf6E8eF3153a920e5e7744961ad9E384
// 2. Set chains
const mainnet = {
 chainId: 1,
 name: "Ethereum",
 currency: "ETH",
 explorerUrl: "https://etherscan.io",
 rpcUrl: "https://cloudflare-eth.com",
};

const bscTestnet = {
 chainId: 97,
 name: "Binance Smart Chain Testnet",
 currency: "BNB",
 explorerUrl: "https://testnet.bscscan.com",
 rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545",
};

const bscMainnet = {
 chainId: 56,
 name: "Binance Smart Chain",
 currency: "BNB",
 explorerUrl: "https://bscscan.com",
 rpcUrl: "https://bsc-dataseed1.binance.org",
};

// 3. Create a metadata object
const metadata = {
 name: "18plus",
 description: "The first real adult coin",
 url: "https://modeland.ai/", // origin must match your domain & subdomain
 icons: ["https://modeland.ai/logo.jpg"],
};

// 4. Create Ethers config
const ethersConfig = defaultConfig({
 /*Required*/
 metadata,

 /*Optional*/
 enableEIP6963: true, // true by default
 enableInjected: true, // true by default
 enableCoinbase: true, // true by default
 rpcUrl: "https://bsc-dataseed1.binance.org", // used for the Coinbase SDK
 defaultChainId: 56, // used for the Coinbase SDK
});

// 5. Create a Web3Modal instance
createWeb3Modal({
 ethersConfig,
 chains: [bscMainnet],
 projectId,
 enableAnalytics: true, // Optional - defaults to your Cloud configuration
});

function Presale() {
 const [balance, setBalance] = useState(0);
 const [claimedBNB, setClaimedBNB] = useState(0);
 const [claimableTokens, setClaimableTokens] = useState(0);
 const [tierSupply, setTierSupply] = useState(0);
 const [tierHoldings, setTierHoldings] = useState(0);
 const [ref, setRef] = useState(0);
 const [tierPrice, setTierPrice] = useState(0);
 const [max, setMax] = useState(0);
 const [refCode, setRefCode] = useState("REF*****");
 const [tierPriceRaw, setTierPriceRaw] = useState("");
 const [referer, setReferer] = useState("0x0");
 const [loading, setLoading] = useState(false);
 const [tier, setTier] = useState(1);
 const [userWeight, setUserWeight] = useState(0);
 const [totalWeight, setTotalWeight] = useState(0);
 const [menu, setMenu] = useState("mint");
 const [owner, setOwner] = useState("");

 const { address, chainId, isConnected } = useWeb3ModalAccount();
 const { walletProvider } = useWeb3ModalProvider();

 const getQueryParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const val = urlParams.get("q");
  if (val !== null && val !== undefined) {
   setReferer(val);
  } else {
   setReferer("0x0");
  }
 };

 useEffect(() => {
  getQueryParam();
 }, []);

 const getBalance = async (account) => {
  if (!account) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.balanceOf(account);
   // console.log("WEI", wei);
   setBalance(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getBalance(address);
 }, [address]);

 const getUserWeight = async (account) => {
  if (!account) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.getUserWeight(account);
   // console.log("WEI", wei);
   setUserWeight(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getUserWeight(address);
 }, [address]);

 const getClaimableRewards = async (account) => {
  if (!account) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.claimableRewards(account);
   // console.log("WEI", wei);
   setClaimableTokens(formatUnits(wei.toString(), 18));
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getClaimableRewards(address);
 }, [address]);

 const getClaimedBNB = async (account) => {
  if (!account) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.claimedBNB(account);
   // console.log("WEI", wei);
   setClaimedBNB(formatUnits(wei.toString(), 18));
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getClaimedBNB(address);
 }, [address]);

 const getTierSupply = async (tier) => {
  if (!tier || tier === 0) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.getTierSupply(tier);
   // console.log("WEI", wei);
   setTierSupply(tier === 1 ? +wei.toString() + 1 : wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getTierSupply(tier);
 }, [tier]);

 const getTierHoldings = async (tier) => {
  if (!tier || tier === 0) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.tierHoldings(tier.toString());
   // console.log("WEI", wei);
   setTierHoldings(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getTierHoldings(tier);
 }, [tier]);

 const getOwner = async () => {
  try {
   const contract = await ReadContract();

   const wei = await contract.owner();
   // console.log("WEI", wei);
   setOwner(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getOwner();
 }, []);

 const getTierPrice = async (tier) => {
  if (!tier || tier === 0) return;
  setLoading(true);
  try {
   const contract = await ReadContract();

   const wei = await contract.tierPrices(tier);
   // console.log("WEI", wei);
   setTierPrice(formatUnits(wei.toString(), 18));
   setTierPriceRaw(wei.toString());
  } catch (err) {
   console.log(err);
  }
  setLoading(false);
 };

 useEffect(() => {
  getTierPrice(tier);
 }, [tier]);

 const getMax = async () => {
  try {
   const contract = await ReadContract();

   const wei = await contract.max();
   // console.log("WEI", wei);
   setMax(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getMax();
 }, []);

 const getTotalWeight = async () => {
  try {
   const contract = await ReadContract();

   const wei = await contract.getTotalWeight();
   // console.log("WEI", wei);
   setTotalWeight(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getTotalWeight();
 }, []);

 const getRefCode = async (account) => {
  if (!account) return;
  try {
   const contract = await ReadContract();

   const wei = await contract.walletReferralCodes(account);
   // console.log("WEI", wei);
   setRefCode(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getRefCode(address);
 }, [address]);

 const getRef = async () => {
  try {
   const contract = await ReadContract();

   const wei = await contract.ref();
   // console.log("WEI", wei);
   setRef(wei.toString());
  } catch (err) {
   console.log(err);
  }
 };

 useEffect(() => {
  getRef();
 }, []);

 function formatNumber(number) {
  return Number(number).toLocaleString("en-US", {
   minimumFractionDigits: 2,
   maximumFractionDigits: 2,
  });
 }

 const mint = async () => {
  if (!isConnected) return;

  setLoading(true);
  const provider = new BrowserProvider(walletProvider);
  const signer = await provider.getSigner();
  const contract = new Contract(ca, abi, signer);
  //console.log("Mint args:", tier.toString(), referer, tierPriceRaw.toString());
  // console.log("Contract:", contract);
  let tx;
  try {
   if (address.toLowerCase() !== owner.toLowerCase()) {
    tx = await contract.mint(tier, referer, {
     value: tierPriceRaw,
    });
   } else {
    tx = await contract.mint(tier, referer);
   }

   const interval = setInterval(async () => {
    try {
     const receipt = await provider.getTransactionReceipt(tx.hash);
     if (receipt) {
      clearInterval(interval);
      await getBalance(address);
      await getRefCode(address);
      await getClaimableRewards(address);
      await getTierSupply(tier);
      await getTierHoldings(tier);
      alert(
       "Your NFT purchase was successful and your referral link is now active."
      );
      setLoading(false);
     }
    } catch (error) {
     console.log("TX ERROR", error);
     clearInterval(interval);
     setLoading(false);
    }
   }, 2000);
  } catch (error) {
   console.log("PURCHASE ERROR", error);
   let errorMessage =
    error.code === 4001 ? "The request was rejected!" : error.message;
   alert(errorMessage);
   setLoading(false);
  }
 };

 const claim = async () => {
  if (!isConnected) return;
  if (+claimableTokens <= 0) {
   return alert("No tokens to claim at the moment.");
  }
  setLoading(true);
  const provider = new BrowserProvider(walletProvider);
  const signer = await provider.getSigner();
  const contract = new Contract(ca, abi, signer);
  // console.log("Mint args:", tier.toString(), "0x0", tierPriceRaw.toString());
  // console.log("Contract:", contract);

  try {
   const tx = await contract.claimRewards();

   const interval = setInterval(async () => {
    try {
     const receipt = await provider.getTransactionReceipt(tx.hash);
     if (receipt) {
      clearInterval(interval);
      await getClaimedBNB(address);
      //  await getRefCode(address);
      await getClaimableRewards(address);
      //  await getTierSupply(tier);
      //  await getTierHoldings(tier);
      alert("Your reflection rewards were paid to your wallet in BNB.");
      setLoading(false);
     }
    } catch (error) {
     console.log("TX ERROR", error);
     clearInterval(interval);
     setLoading(false);
    }
   }, 2000);
  } catch (error) {
   console.log("CLAIM ERROR", error);
   let errorMessage =
    error.code === 4001 ? "The request was rejected!" : error.message;
   alert(errorMessage);
   setLoading(false);
  }
 };

 const copy = (text) => {
  if (text) {
   if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(
     () => {
      //  console.log("Token copied to clipboard!");
      alert(`Copied to clipboard`);
     },
     (err) => {
      alert(`Could not copy text: ${err}`);
     }
    );
   } else {
    // Fallback method for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
     document.execCommand("copy");
     alert(`Copied to clipboard`);
    } catch (err) {
     alert(`Could not copy text: ${err}`);
    }
    document.body.removeChild(textArea);
   }
  }
 };

 return (
  <div className="home-1-hero-con">
   <SpinnerOverlay loading={loading} />
   <div
    data-animation="default"
    data-collapse="medium"
    data-duration={400}
    data-easing="ease"
    data-easing2="ease"
    role="banner"
    className="nav-fixed-menu w-nav"
   >
    <div className="line-on-top" style={{ backgroundColor: "black" }}>
     {/*-- <p class="white-text-bar">Presale</p>
         <a target='_blank' href="https://www.pinksale.finance/solana/launchpad/EySRFsiJ7J1v9W64z6BLxEejDCHDggcX1D82T5jzfV5c" class="black-button smaller w-button">See Details</a>
     */}
    </div>
    <div data-w-id="742c1d3d-0076-6f29-cf79-8d33af42fc71" className="line" />
    <div className="blur-bg" />
    <div className="blur-bg-dark" />
    <div className="nav-hero-container w-container">
     <div className="menu-item-wrapper">
      <a
       href="https://reflectaprotocol.com/"
       aria-current="page"
       className="brand-logo black-logo w-nav-brand w--current"
      >
       <img
        src="./img/logo.png"
        loading="lazy"
        width={444}
        height={444}
        alt="Reflecta Coin Logo"
        srcSet="./img/logo.png 500w, ./img/logo.png 900w"
        sizes="(max-width: 479px) 160px, (max-width: 1279px) 65px, (max-width: 1439px) 5vw, 65px"
        className="logo-ersti"
       />
      </a>
      <nav role="navigation" className="nav-menu-2 w-nav-menu">
       <div className="nav-menu-shadow-overlay-4">
        <div className="tablet-menu-4">
         <div className="close-menu-button-3 w-nav-button">
          <img
           src="63c10f5d67846ca7b27ca55b/63c155ba2b5c7835ff19d720_x_icon.webp"
           loading="lazy"
           alt=""
           className="nav-close-icon-4"
          />
         </div>
        </div>
        <div className="dropdown-menu-3">
         <div className="top-tablet-menu-3">
          <div className="border-wrap-3">
           <a
            href="https://reflectaprotocol.com/"
            aria-current="page"
            className="nav-link dropdown-header-item w-inline-block w--current"
           >
            <p className="nav-intro-item">HOME</p>
           </a>
           <button
            className="nav-link dropdown-header-item w-inline-block"
            onClick={() => setMenu("mint")}
           >
            <p className="nav-intro-item">MINT NFT</p>
           </button>

           <button
            className="nav-link dropdown-header-item w-inline-block"
            onClick={() => setMenu("claim")}
           >
            <p className="nav-intro-item">CLAIM REWARDS</p>
           </button>
          </div>
         </div>
         <div className="login-tablet-wrap-2">
          <w3m-button balance={"show"} />
         </div>
        </div>
       </div>
      </nav>
      <div className="menu-button-3 w-nav-button">
       <img
        src="64bc3e1a76f02c3a8cf863a2/64fb8e52f5e20f6ac3a0927a_Group%20103.svg"
        loading="lazy"
        alt=""
        className="menu-button"
       />
      </div>
      <div className="right-header-wrapper">
       <div className="btn-wrap">
        <w3m-button balance={"show"} />
       </div>
      </div>
     </div>
    </div>
   </div>
   <section className="home-1-banner">
    <div className="base-container pos-relative">
     {menu === "claim" && (
      <>
       <div className="about-saas-wrap-left" id="about">
        <div className="about-company-container">
         <h2
          data-w-id="56d0d153-aaa5-0298-6eef-63a6d36b0c0c"
          className="h2-title"
         >
          CLAIM YOUR <span className="gradient">REFLECTION</span> REWARDS
         </h2>
         <div className="row" style={{ marginTop: "30px" }}>
          <div className="col-6">
           <img src={`./img/hero.jpg`} style={{ width: "auto" }} />
          </div>
          <div className="col-6" style={{ borderLeft: "3px solid #fff" }}>
           {isConnected && balance > 0 && (
            <>
             <div className="tier-info">
              <span>
               <b>Your NFTs:</b>
              </span>
              <span>{balance}</span>
             </div>
             <div className="tier-info">
              <span>
               <b>Your Share:</b>
              </span>
              <span>
               {userWeight} out of {totalWeight} shares
              </span>
             </div>
             <div className="tier-info">
              <span>
               <b>Total Claimed:</b>
              </span>
              <span>{claimedBNB} BNB</span>
             </div>
             <div className="tier-info">
              <span>
               <b>Claimable Now:</b>
              </span>
              <span>{claimableTokens} BNB</span>
             </div>
             {+claimableTokens > 0 && (
              <div
               className="primary-gradient-button _100-percent w-button"
               onClick={claim}
              >
               CLAIM {claimableTokens} BNB
              </div>
             )}
            </>
           )}
           {+balance === 0 && (
            <span>
             <b>You must own an NFT to be eligible for reflections.</b>
            </span>
           )}
           {+balance > 0 && (
            <div style={{ marginTop: "30px" }}>
             <h5 className="h2-title">
              YOUR <span className="gradient">REFERRAL</span> LINK
             </h5>
             <p>&nbsp;</p>
             <div
              style={{
               gap: 15,
               justifyContent: "start",
               alignItems: "center",
               fontWeight: "bolder",
               display: "flex",
               padding: "3px",
              }}
             >
              <span className="gradient">
               {"https://nft.reflectaprotocol.com/?q=" + refCode}
              </span>
              <img
               src={copyIcon}
               height={30}
               style={{ cursor: "pointer" }}
               onClick={() =>
                copy("https://nft.reflectaprotocol.com/?q=" + refCode)
               }
               aria-hidden="true"
              />
             </div>
             <p></p>
             <div className="text-center pt-2">
              When someone mints using your referral link, you earn {ref}% of
              that sale — automatically. 🚀
             </div>
            </div>
           )}
          </div>
         </div>
        </div>
       </div>
      </>
     )}
     {menu === "mint" && (
      <>
       <div className="about-saas-wrap-left" id="about">
        <div className="about-company-container">
         <h2
          data-w-id="56d0d153-aaa5-0298-6eef-63a6d36b0c0c"
          className="h2-title"
         >
          MINT YOUR <span className="gradient">REFLECTA</span> NFTs
         </h2>
         <div className="row" style={{ marginTop: "30px" }}>
          <div className="col-6">
           <img src={`./img/tier${tier}.png`} style={{ width: "auto" }} />
          </div>
          <div className="col-6" style={{ borderLeft: "3px solid #fff" }}>
           <h5 className="h2-title">
            CHOOSE AN <span className="gradient">NFT TIER</span>
           </h5>
           <div className="radio-group">
            <label
             className={`radio-label ${tier === 1 ? "selected" : ""}`}
             htmlFor="tier1"
            >
             <input
              type="radio"
              value={1}
              checked={tier === 1}
              onChange={() => setTier(1)}
              id="tier1"
             />
             Tier 1
            </label>

            <label
             className={`radio-label ${tier === 2 ? "selected" : ""}`}
             htmlFor="tier2"
            >
             <input
              type="radio"
              value={2}
              checked={tier === 2}
              onChange={() => setTier(2)}
              id="tier2"
             />
             Tier 2
            </label>

            <label
             className={`radio-label ${tier === 3 ? "selected" : ""}`}
             htmlFor="tier3"
            >
             <input
              type="radio"
              value={3}
              checked={tier === 3}
              onChange={() => setTier(3)}
              id="tier3"
             />
             Tier 3
            </label>
           </div>

           {tier > 0 && (
            <>
             <div className="tier-info">
              <span>
               <b>Tier {tier} Price:</b>
              </span>
              <span>{tierPrice} BNB</span>
             </div>
             <div className="tier-info">
              <span>
               <b>Tier {tier} Supply:</b>
              </span>
              <span>
               {tier === 1 ? +tierSupply - +tierHoldings : tierSupply} NFTs
              </span>
             </div>
             <div className="tier-info">
              <span>
               <b>Total Supply:</b>
              </span>
              <span>{max} NFTs</span>
             </div>
             <div className="tier-info">
              <span>
               <b>Max Supply:</b>
              </span>
              <span>7,777 NFTs</span>
             </div>
             {isConnected ? (
              <div
               className="primary-gradient-button _100-percent w-button"
               onClick={mint}
              >
               MINT NOW FOR {tierPrice} BNB
              </div>
             ) : (
              <w3m-button balance={"hide"} />
             )}
            </>
           )}
           {+balance > 0 && (
            <div style={{ marginTop: "30px" }}>
             <h5 className="h2-title">
              YOUR <span className="gradient">REFERRAL</span> LINK
             </h5>
             <p>&nbsp;</p>
             <div
              style={{
               gap: 15,
               justifyContent: "start",
               alignItems: "center",
               fontWeight: "bolder",
               display: "flex",
               padding: "3px",
              }}
             >
              <span className="gradient">
               {"https://nft.reflectaprotocol.com/?q=" + refCode}
              </span>
              <img
               src={copyIcon}
               height={30}
               style={{ cursor: "pointer" }}
               onClick={() =>
                copy("https://nft.reflectaprotocol.com/?q=" + refCode)
               }
               aria-hidden="true"
              />
             </div>
             <p></p>
             <div className="text-center pt-2">
              When someone mints using your referral link, you earn {ref}% of
              that sale — automatically. 🚀
             </div>
            </div>
           )}
          </div>
          <div
           className="col-12"
           style={{ textAlign: "center", marginTop: "30px" }}
          >
           <img src="./img/earnings.jpg" />
          </div>
         </div>
        </div>
       </div>
      </>
     )}
     <p>&nbsp;</p>
    </div>
    <div className="gradient-con banner">
     <div className="purple-gradient" />
     <div className="blue-gradient" />
     <div className="purple-gradient grad-5" />
     <div className="purple-gradient grad-6" />
     <div className="purple-gradient grad-9" />
     <div className="purple-gradient grad-10" />
    </div>
   </section>
   <p>&nbsp;</p>
   <p>&nbsp;</p>
   <p>&nbsp;</p>
   <section className="new-footer">
    <div className="base-container pos-relative w-container">
     <div
      data-w-id="894ca8a0-ba0a-ac29-fa23-c515a33de98d"
      className="footer-bottom"
     >
      <div className="rights-wrap">
       <div className="footer-copyright-2">
        Copyright 2025 © Reflecta Protocol
       </div>
      </div>
      <div className="rights-wrap">
       <div
        data-w-id="894ca8a0-ba0a-ac29-fa23-c515a33de956"
        style={{ display: "flex", justifyContent: "center", gap: "20px" }}
       >
        <a
         aria-label="Twitter"
         href="https://x.com/Reflectatoken"
         target="_blank"
         className="footer-socials tw"
        />
        <a
         aria-label="Telegram"
         href="https://t.me/reflectaprotocol"
         target="_blank"
         className="footer-socials tg"
        >
         <img src="./64bc3e1a76f02c3a8cf863a2/tg.png" />
        </a>
       </div>
      </div>
     </div>
    </div>
    <div className="footer-ov" />
   </section>
  </div>
 );
}

export default Presale;
